/*
 * Copyright (c) 2023
 * 
 * Created Date: Thursday, November 16th 2023, 1:59:47 pm
 * Author: 🫰Aris Bimas Nugroho
 * 
 */
import React from 'react'

export default function EmptyData() {
    return (
        <div className='container-empty-data'>No Data</div>
    )
}
